import React from 'react';
import Toolbar from "@mui/material/Toolbar";
import Drawer from "@mui/material/Drawer";
import { AppDrawer } from './Sidebar.styles';

const drawerWidth = 0;

export const Sidebar = () => {

    return (
        <>
            <Drawer
                variant="permanent"
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    position: 'static',
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                    },
                }}
            >
                <Toolbar variant="dense" />
                Drawer
            </Drawer>
        </>
    )
}